import { t } from "@travily/i18n";
import { Checkbox } from "@ui/components/Checkbox";
import { CheckboxGroup } from "@ui/primitives/CheckboxGroup";
import { localizedLanguageName } from "@ui/utils/language-name";
import { useMemo } from "react";
import { INSTRUCTION_LANGUAGE_CODES } from "../constants";

export interface InstructionLanguageFilterProps {
  onChange: (values: string[]) => void;
  selected: string[];
}

export function InstructionLanguageFilter({ onChange, selected }: InstructionLanguageFilterProps) {
  const items = useMemo(
    () => INSTRUCTION_LANGUAGE_CODES.map((code) => ({ code, label: localizedLanguageName(code) })),
    [],
  );

  return (
    <CheckboxGroup
      aria-label={t("components.views.programs.search.instruction_language_label")}
      className="grid grid-cols-3 gap-x-5 gap-y-4"
      onChange={onChange}
      value={selected}
    >
      {items.map((item) => (
        <Checkbox key={item.code} label={item.label} value={item.code} />
      ))}
    </CheckboxGroup>
  );
}
